import React from "react";
import { FlatButton, TextField, Checkbox } from "material-ui";

import BaseOverlay from "./base.jsx";

const styles = {
  note: {
    marginTop: "1em",
    fontSize: "0.8em"
  }
};

class InviteContentCreatorOverlay extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      recipient: "",
      title_requested_media: []
    };

    this.invite = this.invite.bind(this);
  }

  invite() {
    this.props.onInvite(this.state.recipient, {
      title_requested_media: this.state.title_requested_media
    });
  }

  render() {
    let { onRequestClose, eventBucket, film, inviteMode } = this.props;

    return (
      <BaseOverlay
        onRequestClose={onRequestClose}
        useMuiDefaultStyle={true}
        actions={[
          <FlatButton label="Cancel" onTouchTap={onRequestClose} />,
          <FlatButton
            primary={true}
            label="Send invite"
            disabled={
              !this.state.recipient ||
              (inviteMode === "title" &&
                this.state.title_requested_media.length === 0)
            }
            onTouchTap={this.invite}
          />
        ]}
      >
        {inviteMode === "title" ? (
          <div>
            Welcome to the Eventive Print Traffic beta for "{film.name}". Please
            provide the content creator's email address and the desired assets.
          </div>
        ) : (
          <div>
            Please enter a recipient for the upload invite to "{film.name}".
          </div>
        )}
        <TextField
          floatingLabelText="Content creator email address"
          floatingLabelFixed={true}
          value={this.state.recipient}
          type="email"
          onChange={e => this.setState({ recipient: e.target.value })}
          autoFocus
        />
        {inviteMode === "title" ? (
          <div style={{ marginTop: 10 }}>
            <div style={{ marginBottom: 10 }}>
              What is requested for this title?
            </div>
            <Checkbox
              label="Virtual content"
              checked={this.state.title_requested_media.includes("virtual")}
              onCheck={(e, checked) =>
                this.setState({
                  title_requested_media: this.state.title_requested_media
                    .filter(m => m !== "virtual")
                    .concat(checked ? ["virtual"] : [])
                })
              }
            />
            <Checkbox
              label={
                eventBucket.title_delivery_config.accepted_print_formats.includes(
                  "digital_file"
                )
                  ? "Digital file (non-DCP)"
                  : "Print (DCP)"
              }
              checked={this.state.title_requested_media.includes("print")}
              onCheck={(e, checked) =>
                this.setState({
                  title_requested_media: this.state.title_requested_media
                    .filter(m => m !== "print")
                    .concat(checked ? ["print"] : [])
                })
              }
            />
            <Checkbox label="Title metadata (coming soon)" disabled />
          </div>
        ) : null}
        <div style={styles.note}>
          The content creator will receive an email invitation to{" "}
          {inviteMode === "title"
            ? "deliver their assets"
            : "upload their content"}{" "}
          and grant permissions to "{eventBucket.name}".
        </div>
      </BaseOverlay>
    );
  }
}

export default InviteContentCreatorOverlay;



// WEBPACK FOOTER //
// ./src/app/components/partials/overlays/invite-content-creator.jsx